import { ApplicationConfig, importProvidersFrom, inject, isDevMode, LOCALE_ID, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideServiceWorker } from '@angular/service-worker';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeAr from '@angular/common/locales/ar';
import { routes } from './app.routes';
import { LocaleService } from '../services/locale/locale.service';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateModule, TranslateLoader, TranslateCompiler } from '@ngx-translate/core';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DomService } from '../services/modal-service/DOM.service';
import { ModalService } from 'src/services/modal-service/modal.Service';
import { ConfigService } from 'src/services/config/config.service';
import { OperatorConfigService } from 'src/services/operator-config/operator-config.service';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { LOCALE_CONFIG } from 'ngx-daterangepicker-material';

registerLocaleData(localeFr);
registerLocaleData(localeAr);

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

/** Capacitor injects window.Capacitor in native shells; no import needed (keeps it out of the web bundle). */
export function isNativeShell(): boolean {
  return !!(window as any).Capacitor?.isNativePlatform?.();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideRouter(routes),
    importProvidersFrom(TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler
      },
      defaultLanguage: 'fr'
    })),
    provideAppInitializer(()=> {
      let config = inject(ConfigService);
      let operatorConfig = inject(OperatorConfigService);

      // Start the per-operator registry here rather than leaving it to whichever
      // component happens to inject OperatorConfigService first. It feeds Banko
      // (pushed into CagnotteService), currency, languages, translations and the
      // partner-theming allowlist, and "nobody injected it" would turn all five
      // off with nothing reported.
      //
      // Not awaited, on purpose: the registry is optional and bootstrap must not
      // block on a third-party bucket. It waits on configsLoad$ internally, so
      // starting it before loadAppConfigs() resolves is safe.
      return config.loadAppConfigs().then(() => operatorConfig.prime())
    }),
    LocaleService,
    { provide: LOCALE_CONFIG, useValue: {} },
    DomService,
    ModalService,
    { provide: LOCALE_ID, useFactory: (localeService: LocaleService) => localeService.locale, deps: [LocaleService] },
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {hasBackdrop: true}},
    provideServiceWorker('ngsw-worker.js', {
      // Web builds only: the native Capacitor shell ships its assets locally.
      enabled: !isDevMode() && !isNativeShell(),
      registrationStrategy: 'registerWhenStable:30000'
    })

  ]
};
